import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { filter } from 'rxjs';

import { AuthService, ExpandedUsersResponse } from '../services/auth.service';
import { UsersResponse } from '../types/pocketbase-types';

export const meResolver: ResolveFn<ExpandedUsersResponse | UsersResponse> = () => {
  const authService = inject(AuthService);

  return authService.getMe().pipe(filter((user): user is ExpandedUsersResponse => !!user));
};
